// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* ------------------------------------------------------------------------------------------ */
/* Based on the "Color Tokens" view --------------------------------------------------------- */
/* ------------------------------------------------------------------------------------------ */
/* For "focus.color", refer to the adjacent "focus.ts" file --------------------------------- */
/* ------------------------------------------------------------------------------------------ */

const colors: Styleguide["colors"] = {
    primary: {
        main: "#0061A8", // Primary -> Main
        contrast: "#ffffff", // None, look at primary button text color
        light: "#0080db", // Primary -> Light
        dark: "#00365c", // Primary -> Dark
    },
    secondary: {
        main: "#e8f2fc", // Secondary -> Main
        contrast: "#1a313c", // None, look at secondary button text color
        light: "#f5faff", // Secondary -> Light
        dark: "#a5b7c9", // Secondary -> Dark
    },
    tertiary: {
        main: "#131C4B", // Tertiary -> Main
        contrast: "#ffffff", // None, look at tertiary button text color
        light: "#263896", // Tertiary -> Light
        dark: "#090d24", // Tertiary -> Dark
    },
    accent: {
        main: "#e31a36",
        contrast: "#ffffff",
        light: "#ff2441",
        dark: "#b01328",
    },
    common: {
        border: "#e6e6e6", // Black & White -> Border
        borderLight: "#f6f7f9", // Black & White -> Border Light
        borderDark: "#7d858c", // Gray Shades -> Main
        accent: "#f6f7f9", // Gray Shades -> Light
        accentContrast: "#1a313c", // Text Color -> Main
        accentContrastLight: "#7d858c", // Gray Shades -> Main
        background: "#ffffff", // None, look at website background color
        backgroundContrast: "#1a313c", // Text Color -> Main
        disabled: "#c1c8cf", // Gray Shades -> Light
        disabledDark: "#7d858c", // Gray Shades -> Mid
    },
    text: {
        main: "#1a313c", // Text Color -> Main
        accent: "#2A4F61", // Text Color -> Accent
        disabled: "#7d858c", // Gray Shades -> Main
        link: "#0061a8", // Primary -> Main
        linkHover: "#00365c", // Primary -> Dark
        linkAlt: "#1a313c", // Text Color -> Main
        linkAltHover: "#e31a36", // Primary -> Main
        input: "#1a313c ", // Text Color -> Main
    },
    success: {
        main: "#028526", // Alerts/Contrast -> Success
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Success" token
        light: "#ddefe2", // Alerts/Light -> Success
    },
    warning: {
        main: "#F78830", // Alerts/Contrast -> Warning
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Warning" token
        light: "#fff0e4", // Alerts/Light -> Warning
    },
    danger: {
        main: "#DF1642", // Alerts/Contrast -> Error
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Error" token
        light: "#ffe9ef", // Alerts/Light -> Error
    },
    info: {
        main: "#1D8ED5", // Alerts/Contrast -> Info
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Info" token
        light: "#e8f2fc", // Alerts/Light -> Info
    },
    neutral: {
        main: "#7d858c", // None
        contrast: "#ffffff", // None
        light: "#e6e6e6", // None
    },
    invert: {
        main: "#ffffff", // None
        contrast: "#0f0f0f", // None
        dark: "#ececec", // None
    },
    placeholder: {
        main: "#666666", // None, look at header search field text color
        disabled: "#7d858c", // Text Color -> Disabled
    },
    button: {
        disabled: {
            // These colors should be different than the field disabled styles (common.disabled / text.disabled)
            main: "#c1c8cf", // None
            contrast: "#ffffff", // None
        },
    },
    header: {
        main: "#ffffff", // None, look at header background color
        contrast: "#1a313c", // Text Color -> Main
        hover: "#0061a8", // Primary -> Dark
        accent: "#0061a8", // Primary -> Main
        accentHover: "#00365c", // Primary -> Dark
        accentContrast: "#ffffff", // None, should match "primary.contrast"
        secondary: "#e31a36", // Accent -> Main
        secondaryHover: "#b01328", // Accent -> Dark
    },
    menu: {
        mainNavigation: {
            main: "#ffffff", // None, look at main navigation background color
            contrast: "#1a313c", // Text Color -> Main
            hover: "#0061a8", // Primary -> Main
            accent: "#0061a8", // Primary -> Main
            accentContrast: "#ffffff", // None, should match "primary.contrast"
            accentHover: "#0061a8", // Primary -> Main
            border: "#e6e6e6", // Black & White -> Border
        },
        secondaryNavigation: {
            main: "#0061a8", // Primary -> Main
            contrast: "#ffffff", // None, should match "primary.contrast"
            hover: "#e8f2fc", // None, should match "primary.contrast" -- Used "secondary.main"
        },
    },
    footer: {
        main: "#0061a8", // Gray Shades -> Light
        contrast: "#ffffff", // Text Color -> Main
        alt: "#0061a8", // Primary -> Main
        altContrast: "#ffffff", // None, should match "primary.contrast"
    },
    swatch: {
        main: "", // Black & White -> Border
        contrast: "", // Text Color -> Main
        hover: "", // Primary -> Main
        selected: "", // Primary -> Main
        selectedHover: "", // Primary -> Dark
    },
};

export default colors;
